import { STOCK_DOCUMENTS } from "../inventory"

export const PROJECTS = "projects" as const

export type ProjectDocumentType =
    | typeof STOCK_DOCUMENTS


// WEBPACK FOOTER //
// ./src/utils/project/constants.ts